var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PostError',[_c('Dialog',{attrs:{"type":'fail',"content-title":'邮箱激活失败'},model:{value:(_vm.dialogStatus),callback:function ($$v) {_vm.dialogStatus=$$v},expression:"dialogStatus"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }